module.exports = __webpack_public_path__ + "static/media/Interior.77510ba1.jpg";